import React from 'react';
export default (function (_a) {
    var className = _a.className, ariaHidden = _a["aria-hidden"], color = _a.color;
    return (React.createElement("svg", { version: "1.1", id: "Lager_1", x: "0px", y: "0px", className: className, "aria-hidden": ariaHidden, viewBox: "0 0 24 24" },
        React.createElement("g", { id: "Group_3913", transform: "translate(-1480 -81)" },
            React.createElement("g", { id: "Ellipse_13", transform: "translate(1485 81)" },
                React.createElement("circle", { fill: "#FFFFFF", cx: "7", cy: "7.29", r: "6.29" }),
                React.createElement("circle", { fill: "none", stroke: "#020202", strokeWidth: "2", cx: "7", cy: "7.29", r: "5.14" })),
            React.createElement("g", { id: "Rectangle_214", transform: "translate(1480 87)" },
                React.createElement("rect", { y: "1.86", fill: "#FFFFFF", width: "24", height: "16" }),
                React.createElement("rect", { x: "1.14", y: "3", fill: "none", stroke: "#020202", strokeWidth: "2", width: "21.71", height: "13.71" })))));
});
